// Admin API client for /v1/admin/case-image-qc. Used by the
// CaseImageQc page to surface per-case original/MIO output for QC review.

import axios from '@/api/axios.config'

export type CaseImageJobStatus =
  | 'QUEUED'
  | 'PROCESSING'
  | 'COMPLETED'
  | 'FAILED'

export type CaseImageEdits = Record<string, number> | null

export type CaseImageQcRow = {
  id: string
  sortOrder: number
  default: boolean
  uploadSource: string | null
  originalUrl: string
  mioUrl: string | null
  mioEdits: CaseImageEdits
  mioChangeScore: number | null
  width: number | null
  height: number | null
  fileSize: number | null
  originalFileName: string | null
  orientation: string | null
  error: string | null
  createdAt: string
  latestJobStatus: CaseImageJobStatus | null
  latestJobError: string | null
}

export type CaseImageQcResponse = {
  case: {
    id: string
    nameOfDeceased: string | null
    funeralHomeName: string | null
  }
  orderId: string | null
  images: CaseImageQcRow[]
}

export type CaseImageQcLookupKind = 'caseId' | 'orderId'

export const fetchCaseImageQc = async (
  kind: CaseImageQcLookupKind,
  id: string,
) =>
  await axios.get<CaseImageQcResponse>('/admin/case-image-qc', {
    params: { [kind]: id },
  })
